export default "https://cdn-static.gokick.com/assets/f3c431ab621bc71377aad81f5421d83f1421a0d2/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";